import { signInWithCustomToken, signOut } from "firebase/auth";
import { auth } from "./firebaseConfig";
import {
  ref,
  // uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../services/firebaseConfig";

// login firebase users
export const loginFirebaseUser = async (token) => {
  await signInWithCustomToken(auth, token)
    .then((userCredential) => {
      const user = userCredential.user;
      // console.log("User logged out successfully!", user);
    })
    .catch((error) => {
      console.error("Error signing in with custom token:", error);
    });
};

// logout firebase users
export const logoutFirebaseUser = async () => {
  try {
    await signOut(auth);
    console.log("User logged out successfully!");
  } catch (error) {
    console.error("Error logging out:", error.message);
  }
};

// delete old files
export const removeOldFile = (url) => {
  console.log(url);
  // delete image from image server
  const imageRef = ref(storage, url);
  getDownloadURL(imageRef)
    .then(() => {
      // File exists, proceed with deletion
      deleteObject(imageRef)
        .then(() => {
          console.log("File deleted successfully!");
        })
        .catch((error) => {
          console.error("Error deleting file:", error);
        });
    })
    .catch((error) => {
      // File does not exist or other error occurred
      if (error.code === "storage/object-not-found") {
        console.log("File does not exist, no need to delete.");
      } else {
        console.error("Error checking file existence:", error);
      }
    });
};
